import type { JSX } from 'react';
import type { WireSourceHealthRow } from '@logistics/contracts';
import { button } from '../shell/look';
import { navigate } from '../shell/use-route';

/**
 * A failing source, in red, with the way to fix it (design L515–519). The
 * error text comes from a provider, so it is rendered as text only.
 */
export function AlertCard({ row }: { row: WireSourceHealthRow }): JSX.Element {
  return (
    <div className="border-bad grid grid-cols-[10px_minmax(0,1fr)_auto] items-center gap-3.5 rounded-xl border bg-[color-mix(in_oklch,var(--bad)_8%,var(--surf))] px-[18px] py-3.5">
      <span className="bg-bad animate-blink size-2.5 rounded-full" />
      <div className="min-w-0">
        <div className="text-sm font-medium">{row.label}: the last sync failed</div>
        <div className="text-mute mt-0.5 text-[13px] [overflow-wrap:anywhere]">
          {row.lastError ?? 'Check the credentials, or test the connection from Sources.'}
        </div>
      </div>
      <button
        type="button"
        className={button.small}
        onClick={() => navigate({ page: 'sources', action: row.instanceId })}
      >
        Open credentials
      </button>
    </div>
  );
}
